import routesConfig from '../routes-config';

const canSeeRoute = (navOption, roles, userIsAdmin) => {
  const { allowedRoles, isAdmin, hide } = navOption ?? {};
  if (hide) {
    return false;
  }

  if (Array.isArray(allowedRoles) && allowedRoles.length) {
    const userRoles = Array.isArray(roles) ? roles : [];
    const isAllowed = userRoles.some(({ roleName }) =>
      allowedRoles.includes(roleName),
    );

    return isAllowed;
  }

  if (isAdmin && !userIsAdmin) {
    return false;
  }

  return null;
};

export const checkRouteAccess = (
  pathname,
  foundUser,
  roles,
  userIsAdmin,
  history,
) => {
  if (!pathname) {
    return;
  }

  const foundRoute = routesConfig.find(
    (possibleRoute) => pathname === possibleRoute.path,
  );

  if (!foundUser) {
    history.push('/login');
    return;
  }

  if (foundRoute && !canSeeRoute(foundRoute, roles, userIsAdmin)) {
    history.push('/admin/dashboard');
  }
};
